import { render, staticRenderFns } from "./LegalEntitiesIntro.vue?vue&type=template&id=3b9ce0b6&scoped=true"
import script from "./LegalEntitiesIntro.vue?vue&type=script&lang=js"
export * from "./LegalEntitiesIntro.vue?vue&type=script&lang=js"
import style0 from "./LegalEntitiesIntro.vue?vue&type=style&index=0&id=3b9ce0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9ce0b6",
  null
  
)

export default component.exports